import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Map} from 'immutable';

import Box from 'components/box';
import {Label, SearchFail, UniversalDateTime,  UniversalDateWrapper, UniversalSearchWrapper} from 'components/common';
import DocumentsList from './documents-list';
import Spinner from 'spinner';
import Pagination from 'pagination';
import {ButtonDefault, LinkDefault} from 'components/buttons';
import {PageHead} from 'components/header/components';
import Input from 'form/input';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import {searchDocuments, searchDocumentsByDate} from 'redux/actions/admin/documents';

const mapStateToProps = (state) => ({
	documents: state.adminDocuments.get('documentsList'),
	isLoading: state.adminDocuments.get('documentsAreLoading')
});

const mapDispatchToProps = (dispatch) => ({
	searchDocumentsByName: (name, start_date, end_date, offset) => dispatch(searchDocuments(name, start_date, end_date, 10, offset)),
	searchDocumentsByDate: (date) => dispatch(searchDocumentsByDate(date))
});

class DocumentsAll extends Component {

	constructor(props) {
		super(props);

		this.state = {
			search: "",
			search1: true,
			search2: false,
			start_date: moment("01-01-2018", "MM-DD-YYYY"),
			end_date: moment()
		}
		this.searchByName = this.searchByName.bind(this);
		this.onChangeStartDate = this.onChangeStartDate.bind(this);
		this.onChangeEndDate = this.onChangeEndDate.bind(this);
	}

	searchByName(event) {
		this.setState({search: event.target.value})
	}

	onChangeStartDate(date) {
		this.setState({start_date: date})
	}

	onChangeEndDate(date) {
		this.setState({end_date: date})
	}

	componentWillMount() {
		const page = this.props.match.params.page || 1;
		const offset = 10 * (page - 1);
		this.props.searchDocumentsByName(this.state.search, this.state.start_date, this.state.end_date, offset)
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.match.params.page !== nextProps.match.params.page) {
			const page = nextProps.match.params.page || 1;
			const offset = 10 * (page - 1);
			this.props.searchDocumentsByName(this.state.search, this.state.start_date, this.state.end_date, offset)
		}
	}

	render() {

		if (this.props.isFetching || this.props.documents === undefined) {
			return <Spinner/>
		}

		return (<div>
			<Box>
				<PageHead>
					<h2>Реєстр документів</h2>
					<LinkDefault to="/admin/documents/create">Створити документ</LinkDefault>
				</PageHead>

				<UniversalSearchWrapper onSubmit={(event) => {
						event.preventDefault()
						this.props.searchDocumentsByName(this.state.search, this.state.start_date, this.state.end_date)
					}}>
					
					<Input block="block" label="Пошук за номером або назвою документа" placeholder="Введіть номер або назву документа" value={this.state.search} onChange={this.searchByName}/>
					
					<UniversalDateWrapper>
					<UniversalDateTime>
						<Label>Початкова дата</Label>
						<DatePicker locale="uk-UA" selected={this.state.start_date} dateFormat="DD-MM-YYYY" onChange={this.onChangeStartDate}/>
					</UniversalDateTime>
					<UniversalDateTime>
						<Label>Кінцева дата</Label>
						<DatePicker locale="uk-UA" selected={this.state.end_date} dateFormat="DD-MM-YYYY" onChange={this.onChangeEndDate}/>
					</UniversalDateTime>
					</UniversalDateWrapper>
					<ButtonDefault type="submit" value="Пошук"/>
				</UniversalSearchWrapper>

				{
					this.props.documents.get('results').size > 0
						? (<div>
							{
								this.props.isLoading
									? (<Spinner/>)
									: (<DocumentsList documents={this.props.documents.get('results')}/>)
							}

						</div>)
						: (
							<SearchFail>Документи відсутні</SearchFail>
						)
				}

				<Pagination counts={this.props.documents.get('count')} path={`/admin/documents/`} matched={this.props.match.params.page} limits={10}/>
			</Box>
		</div>)
	}
}
DocumentsAll.propTypes = {
	documents: PropTypes.instanceOf(Map),
	onLoad: PropTypes.func,
	isFetching: PropTypes.bool
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DocumentsAll));



// WEBPACK FOOTER //
// ./src/admin/documents/documents.js